import React from 'react';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {makeStyles, TextField, Typography, Divider } from '@material-ui/core';
import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined';


const useStyles = makeStyles(theme => ({
    iconButton: {
        cursor:'pointer',
        marginRight:'-23px',
        color:"#384257",
        marginTop:"3px"
    },
    textField: {
        backgroundColor: "white",
        height:'39px',
        width:'57%',
        
        "& .MuiOutlinedInput-notchedOutline": {
            height: '45px',
            borderColor:'#a6a6a6',
            borderRadius:0
        },
        '& .MuiInputBase-input': {
        fontSize: '14.5px',
        color:'#8e8e8e'
        },
    },
    dayTitle: {
        marginLeft: '12px',
        marginTop:'11px',
        position: 'absolute',
        fontSize:'15px'
    },
    calendarIcon: {
        paddingLeft: 0,
        height:'32px',
        width: '32px',
        stroke: "white",
        strokeWidth: 0.6,
    },
    dividerElement: {
        backgroundColor:'#a6a6a6',
        marginRight:'3px'
    },
    dateWrapper: {
        display: 'flex',
        alignItems: 'center'
    },
}));

function DatePicker({ label, id, handleChange = () => {}, value, minDate, maxDate }) {
    const onChange = date => {
        if (!isNaN(date.getTime())) {
            handleChange(date, id);
        }
    };
    const classes = useStyles();

    let dateDay = value!==undefined ? value.getDate().toString() : '';

    if(dateDay.length===1){
        dateDay = '0'+dateDay
    }

    return <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
            clearable
            format="dd/MM/yyyy"
            value={value}
            onChange={onChange}
            minDate={minDate}
            maxDate={maxDate}
            keyboardIcon={  <div className={classes.dateWrapper}>
                                <Divider aria-hidden="true" orientation="vertical" flexItem className={classes.dividerElement}/>
                                <CalendarTodayOutlinedIcon className={ classes.calendarIcon } />
                                <Typography className={ classes.dayTitle }>
                                    {dateDay}
                                </Typography>
                            </div>}
            KeyboardButtonProps={{
                className: classes.iconButton}}
            TextFieldComponent={props => 
                <TextField 
                    {...props}
                    variant='outlined'
                    size="small"
                    className={classes.textField}
                />}
        />
    </MuiPickersUtilsProvider>
}

export default DatePicker;
